import ReactPixel from 'react-facebook-pixel';
import './styles/CTAPosValue.css'

function CTAPosValue() {

    const handleClickAprender = () => {
            ReactPixel.track('InitiateCheckout', {
                action: 'Clique QUERO APRENDER COM O GRUPO BIOSAFE',
                origem: 'Seção Preço do Produto',
            });
            ReactPixel.trackCustom('Lead', {
                action: 'Clique QUERO APRENDER COM O GRUPO BIOSAFE',
                origem: 'Seção Preço do Produto',
            });
            window.open('https://pay.hotmart.com/K104003704P?off=0tb745dd&checkoutMode=10', '_blank');
    };

    return (
        <div className="cta-container">
            <h3>Inscreva-se agora e comece hoje mesmo!</h3>
            <button className="cta-btn" onClick={handleClickAprender} aria-label="Clique para se inscrever no curso">Quero aprender com o Grupo Biosafe</button>
        </div>
    )
};

export default CTAPosValue;